import React from "react";
import { Button, Box } from "@mui/material";

const LoadMoreButton = ({ onClick }) => {
  return (
    <Box sx={{ mt: 4, textAlign: "center" }}>
      <Button variant="outlined" onClick={onClick}>
        Load More Orders
      </Button>
    </Box>
  );
};

export default LoadMoreButton;
